import React from 'react';
import { arrowUpSvg } from '../../utils';
import { shortenString } from '../../../../components/ListingCard/utils';
import css from './SmallCard.module.css';

const SmallCard = ({ blog, setFocusedBlog, history }) => {
  const blogLink = blog.link;
  return (
    <div className={css.wrapper}>
      <div
        className={css.sectionTop}
        style={{ backgroundImage: `url(${blog.preview.image})` }}
      ></div>
      <div className={css.sectionBottom}>
        <p className={css.title}>{blog.preview.title}</p>
        <p className={css.description}>{shortenString(blog.preview.text, 120)}</p>
        <p
          className={css.readPost}
          onClick={blogLink ? () => history.push(blogLink) : setFocusedBlog}
        >
          Read post {arrowUpSvg}
        </p>
      </div>
    </div>
  );
};

export default SmallCard;
